import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['classroomList', 'continueButton']

  connect() {
    this.observer = new MutationObserver(() => this.checkAllDone())
    this.observer.observe(this.classroomListTarget, {
      childList: true,
      subtree: true,
      attributes: true,
    })
    this.checkAllDone()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  checkAllDone() {
    const rows = this.classroomListTarget.querySelectorAll(
      '[data-sync-status]',
    )
    if (rows.length === 0) return

    const allDone = Array.from(rows).every((row) => {
      const status = row.dataset.syncStatus
      return status === 'done' || status === 'error'
    })

    if (allDone && this.hasContinueButtonTarget) {
      const link = document.createElement('a')
      link.href = this.continueButtonTarget.dataset.completeUrl
      link.className = this.continueButtonTarget.dataset.activeClass
      link.textContent = 'CONTINUE'
      this.continueButtonTarget.replaceWith(link)
    }
  }
}
